import { IModel, Model } from ".";

export interface IDocumentTypeModel extends IModel {
    documentTypeId: number;
    description: string;
}

export class DocumentTypeModel extends Model implements Record<keyof IDocumentTypeModel, any>  {
    documentTypeId: number;
    description: string;

    constructor(params: IDocumentTypeModel) {
        super(params);

        this.documentTypeId = params.documentTypeId;
        this.description = params.description;
    }
}
